import { actions, types } from './actions'

const initialApiState = {
    api: {
        errors: 0,
    },
}

// eslint-disable-next-line default-param-last
export const api = (state: ScoreboardState = initialApiState, action: ActionsUnion<typeof actions>) => {
    switch (action.type) {
        case types.API_CALL_FAILURE:
            return {
                ...state,
                api: {
                    errors: state.api!.errors ? state.api!.errors + 1 : 1,
                },
            }
        case types.API_CALL_SUCCESS:
            return {
                ...state,

                api: {
                    errors: 0,
                },
            }
        case types.API_START_CALLED:
            return {
                ...state,
                api: {
                    errors: "This is getting triggred",
                },
            }
        default:
            return state
    }
}
